import _ from 'lodash'
import { Map } from 'immutable'

export const getSalesforcePaymentPushFields = (state) => {
  let result = []
  let hashEnabledServices = {}
  let hashSetting = {}
  state.getIn(['project', 'Settings', 'store', 'private'], Map()).map((action) => {
    if (action.get('type') == 'PAYMENT' && action.get('enabled', true)) {
      if (!hashSetting[action.get('service')]) {
        hashSetting[action.get('service')] = []
      }
      hashSetting[action.get('service')].push(action.toJS())
      hashEnabledServices[action.get('service')] = true
    }
  })

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Chargent'], false) ||
    hashEnabledServices['Chargent']
  ) {
    let fields = [
      'JSON',
      'paymentMethod__status',
      'paymentMethod__id',
      'paymentMethod__tokens__token',
      'paymentMethod__tokens__id',
      'paymentMethod__tokens__gatewayId',
      'logs__interactionStatus',
      'logs__id',
      'logs__gatewayResultCode',
      'logs__gatewayId',
      'logs__createdDate',
      'gatewayResponse__gatewayToken',
      'gatewayResponse__gatewayResultCodeDescription',
      'gatewayResponse__gatewayResultCode',
      'gatewayResponse__gatewayMessage',
      'gatewayResponse__gatewayDate',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'CreditGuard',
        label: `CreditGuard / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'CreditGuard'], false) ||
    hashEnabledServices['CreditGuard']
  ) {
    let fields = [
      'JSON',
      'status',
      'statusText',
      'extendedStatus',
      'extendedStatusText',
      'extendedUserMessage',
      'terminalNumber',
      'cardId',
      'cardBin',
      'cardMask',
      'cardLength',
      'cardNo',
      'cardName',
      'cardExpiration',
      'cardType',
      'extendedCardType',
      'blockedCard',
      'lifeStyle',
      'customCardType',
      'creditCompany',
      'cardBrand',
      'cardAcquirer',
      'serviceCode',
      'transactionType',
      'creditType',
      'currency',
      'baseCurrency',
      'baseAmount',
      'transactionCode',
      'total',
      'firstPayment',
      'periodicalPayment',
      'numberOfPayments',
      'clubId',
      'validation',
      'idStatus',
      'cvvStatus',
      'authSource',
      'authNumber',
      'fileNumber',
      'slaveTerminalNumber',
      'slaveTerminalSequence',
      'eci',
      'clientIp',
      'email',
      'cavv',
      'user',
      'addonData',
      'supplierNumber',
      'id',
      'shiftId1',
      'shiftId2',
      'shiftId3',
      'shiftTxnDate',
      'cgUid',
      'cardHash',
      'acquirerData',
      'ashraitEmvData',
      'dateTime',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'CreditGuard',
        label: `CreditGuard / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'iCredit'], false) ||
    hashEnabledServices['iCredit']
  ) {
    let fields = [
      'JSON',
      'TransactionToken',
      'TransactionCreditTermsDescription',
      'TransactionTypeDescription',
      'TransactionCurrencyDescription',
      'TransactionCurrency',
      'CustomerTransactionId',
      'TransactionParamJ',
      'TransactionType',
      'TransactionDateTime',
      'TransactionTransAmount',
      'TransactionTerminalNum',
      'TransactionTerminalName',
      'TransactionStatus',
      'TransactionSolekSapak',
      'TransactionNumOfPayment',
      'TransactionNonFirstAmount',
      'TransactionForeignSign',
      'TransactionFirstAmount',
      'TransactionDefrayelCompany',
      'TransactionCreditTerms',
      'TransactionCardHolderId',
      'TransactionCardProducer',
      'TransactionCardDueDateMMYY',
      'TransactionCardNum',
      'TransactionCardName',
      'TransactionAuthNum',
      'TransactionAmount',
      'SaleTime',
      'VatNumber',
      'IdNumber',
      'DocumentType',
      'DocumentNum',
      'DocumentURL',
      'PhoneNumber',
      'CustomerId',
      'CustomerLastName',
      'CustomerFirstName',
      'Custom1',
      'Discount',
      'ItemDescription1',
      'ItemUnitPrice1',
      'ItemQuantity1',
      'ItemCatalogNumber1',
      'ItemId1',
      'NumberOfItems',
      'GroupPrivateToken',
      'SaleId',
      'TransactionCardLabel',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'iCredit',
        label: `iCredit / ${field}`,
        value: field,
      })
    })
  }
  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Pelecard'], false) ||
    hashEnabledServices['Pelecard']
  ) {
    let fields = [
      'JSON',
      'ApprovedBy',
      'CallReason',
      'CardHebrewName',
      'CardHolderAddress',
      'CardHolderCity',
      'CardHolderCountry',
      'CardHolderEmail',
      'CardHolderID',
      'CardHolderName',
      'CardHolderPhone',
      'CardHolderZipCode',
      'ConfirmationKey',
      'CreditCardAbroadCard',
      'CreditCardBrand',
      'CreditCardCompanyClearer',
      'CreditCardCompanyIssuer',
      'CreditCardExpDate',
      'CreditCardNumber',
      'CreditCardStarsDiscountTotal',
      'CreditType',
      'DebitApproveNumber',
      'DebitCode',
      'DebitTotal',
      'DebitType',
      'FirstPaymentTotal',
      'FixedPaymentTotal',
      'JParam',
      'Reciept',
      'ShvaOutput',
      'ShvaResult',
      'Token',
      'TotalPayments',
      'TransactionId',
      'TransactionInitTime',
      'TransactionPelecardId',
      'TransactionUpdateTime',
      'VoucherId',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'Pelecard',
        label: `Pelecard / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'YaadPay'], false) ||
    hashEnabledServices['YaadPay']
  ) {
    let fields = [
      'JSON',
      'Id',
      'CCode',
      'Amount',
      'ACode',
      'Order',
      'Fild1',
      'Fild2',
      'Fild3',
      'noKPayments',
      'nFirstPayment',
      'firstPayment',
      'Bank',
      'Payments',
      'UserId',
      'Info',
      'errMsg',
      'Brand',
      'Issuer',
      'L4digit',
      'street',
      'city',
      'zip',
      'cell',
      'Coin',
      'Tmonth',
      'Tyear',
      'Hesh',
      'UID',
      'spType',
      'bincard',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'YaadPay',
        label: `YaadPay / ${field}`,
        value: field,
      })
    })
  }

  if (state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'PayPal'], false) || hashEnabledServices['PayPal']) {
    let fields = [
      'JSON',
      'payer_id',
      'item_number1',
      'address_status',
      'protection_eligibility',
      'mc_gross',
      'charset',
      'payment_status',
      'payment_date',
      'address_street',
      'tax',
      'mc_fee',
      'first_name',
      'mc_handling',
      'mc_shipping',
      'address_zip',
      'payer_status',
      'custom',
      'notify_version',
      'address_name',
      'address_country_code',
      'address_city',
      'mc_handling1',
      'num_cart_items',
      'address_country',
      'business',
      'txn_id',
      'tax1',
      'mc_shipping1',
      'payer_email',
      'verify_sign',
      'item_name1',
      'address_state',
      'last_name',
      'payer_business_name',
      'payment_type',
      'txn_type',
      'receiver_id',
      'quantity1',
      'payment_fee',
      'receiver_email',
      'payment_gross',
      'transaction_subject',
      'residence_country',
      'mc_currency',
      'mc_gross_1',
      'ipn_track_id',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'PayPal',
        label: `PayPal / ${field}`,
        value: field,
      })
    })
  }

  if (state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Stripe'], false) || hashEnabledServices['Stripe']) {
    let isToken = false,
      isPayment = false
    if (state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Stripe'], false)) {
      isPayment = true
    }
    _.each(hashSetting['Stripe'], (sett) => {
      if (_.get(sett, ['paymentMode']) === 'token') {
        isToken = true
      } else {
        isPayment = true
      }
    })

    let fields = ['JSON']

    let paymentsFields = [
      'id',
      'object',
      'amount',
      'amount_capturable',
      'amount_received',
      'application',
      'application_fee_amount',
      'canceled_at',
      'cancellation_reason',
      'capture_method',
      'charges',
      'client_secret',
      'confirmation_method',
      'created',
      'currency',
      'customer',
      'description',
      'invoice',
      'last_payment_error',
      'livemode',
      'next_action',
      'on_behalf_of',
      'payment_method',
      'payment_method_options',
      'payment_method_types',
      'receipt_email',
      'review',
      'setup_future_usage',
      'shipping',
      'source',
      'statement_descriptor',
      'statement_descriptor_suffix',
      'status',
      'transfer_data',
      'transfer_group',

      'account_country',
      'account_name',
      'amount_due',
      'amount_paid',
      'amount_remaining',
      'application_fee_amount',
      'attempt_count',
      'attempted',
      'auto_advance',
      'billing',
      'billing_reason',
      'charge',
      'collection_method',
      'created',
      'currency',
      'custom_fields',
      'customer',
      'customer_address',
      'customer_email',
      'customer_name',
      'customer_phone',
      'customer_shipping',
      'customer_tax_exempt',
      'customer_tax_ids',
      'default_payment_method',
      'default_source',
      'default_tax_rates',
      'description',
      'discount',
      'due_date',
      'ending_balance',
      'footer',
      'hosted_invoice_url',
      'invoice_pdf',
      'lines',
      'livemode',
      'next_payment_attempt',
      'number',
      'paid',
      'payment_intent',
      'period_end',
      'period_start',
      'post_payment_credit_notes_amount',
      'pre_payment_credit_notes_amount',
      'receipt_number',
      'starting_balance',
      'statement_descriptor',
      'status',
      'status_transitions',
      'subscription',
      'subtotal',
      'tax',
      'tax_percent',
      'total',
      'total_tax_amounts',
      'webhooks_delivered_at',
      'application_fee',
      'closed',
      'date',
      'forgiven',
      'payment_method_details',
      'charge_info',
      'charge_info_id',
      'charge_info_source',
      'charge_info_source_last4',
      'charge_info_source_exp_year',
      'charge_info_source_exp_month',
      'receipt_url',
    ]

    if (isPayment) {
      fields = fields.concat(paymentsFields)
    }

    if (isToken) {
      fields.push('token')
    }

    fields = _.uniq(fields)

    _.each(fields, function (field) {
      result.push({
        group: 'Stripe',
        label: `Stripe / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Authorize'], false) ||
    hashEnabledServices['Authorize']
  ) {
    let fields = [
      'JSON',
      'responseCode',
      'authCode',
      'avsResultCode',
      'cvvResultCode',
      'cavvResultCode',
      'transId',
      'refTransID',
      'transHash',
      'testRequest',
      'accountNumber',
      'accountType',
      'messages',
      'userFields',
      'transHashSha2',
      'customerProfileId',
      'customerPaymentProfileId',
      'token',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'Authorize',
        label: `Authorize / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'PayPlus'], false) ||
    hashEnabledServices['PayPlus']
  ) {
    let fields = [
      'JSON',
      'transaction_type',
      'uid',
      'payment_page_request_uid',
      'number',
      'type',
      'date',
      'status_code',
      'amount',
      'currency',
      'credit_terms',
      'payments',
      'secure3D',
      'approval_number',
      'voucher_number',
      'more_info',
      'add_data',
      'customer_uid',
      'terminal_uid',
      'items',
      'card_information',
      'recurring_number',
      'four_digits',
    ]
    _.each(fields, function (field) {
      result.push({
        group: 'PayPlus',
        label: `PayPlus / ${field}`,
        value: field,
      })
    })
  }

  if (
    state.getIn(['project', 'Settings', 'eCommerce', 'payment', 'Tranzila'], false) ||
    hashEnabledServices['Tranzila']
  ) {
    let fields = [
      'JSON',
      'bit',
      'bit_pay',
      'notify_url',
      'payment_method',
      'Response',
      'currency',
      'ccno',
      'DclickTK',
      'supplier',
      'expmonth',
      'expyear',
      'tranmode',
      'sum',
      'ConfirmationCode',
      'index',
      'Responsesource',
      'Responsecvv',
      'Responseid',
      'Tempref',
      'DBFIsForeign',
      'DBFcard',
      'cardtype',
      'DBFcardtype',
      'cardissuer',
      'DBFsolek',
      'cardaquirer',
      'tz_parent',
      'myid',
      'benid',
      'TranzilaTK',
      'fpay',
      'spay',
      'npay',
    ]

    _.each(fields, function (field) {
      result.push({
        group: 'Tranzila',
        label: `Tranzila / ${field}`,
        value: field,
      })
    })
  }
  return result
}

export const getSalseForceFieldType = (searchType) => {
  if (!searchType) {
    return 'string'
  }
  var groupeTypes = {
    string: [
      'string',
      'auto number',
      'email',
      'phone',
      'picklist',
      'multi-select',
      'multipicklist',
      'picklist',
      'text',
      'textarea',
      'long text area',
      'rich text area',
      'url',
      'reference',
    ],
    boolean: ['checkbox', 'boolean'],
    number: [
      'double',
      'currency',
      'formula',
      'number',
      'percent',
      'roll-up summary',
      'date',
      'date/time',
      'datetime',
      'time',
      'int',
    ],
  }
  var foundType = 'string'
  _.each(groupeTypes, function (list, type) {
    if (list.indexOf(String(searchType).toLowerCase()) > -1) {
      foundType = type
    }
  })
  return foundType
}

export const getSFFieldType = (searchType) => {
  if (!searchType) {
    return 'string'
  }
  var groupeTypes = {
    string: [
      'string',
      'auto number',
      'email',
      'phone',
      'picklist',
      'multi-select',
      'multipicklist',
      'picklist',
      'text',
      'textarea',
      'long text area',
      'rich text area',
      'url',
      'reference',
    ],
    boolean: ['checkbox', 'boolean'],
    number: ['double', 'currency', 'formula', 'number', 'percent', 'roll-up summary', 'int'],
    date: ['date'],
    time: ['time'],
    datetime: ['date/time', 'datetime'],
  }
  var foundType = 'string'
  _.each(groupeTypes, function (list, type) {
    if (list.indexOf(String(searchType).toLowerCase()) > -1) {
      foundType = type
    }
  })
  return foundType
}

export const sfTypeForFFControlType = (type) => {
  const groupedTypes = getSFFieldType(type)
  switch (type) {
    case 'datetime':
      return 'datetime'
    case 'time':
      return 'time'
    case 'date':
      return 'date'
    case 'number':
      return 'number'
    case 'checkbox':
    case 'boolean':
      return 'boolean'
    case 'string':
      return 'text'
    case 'picklist':
      return 'picklist'
    case 'multi-select':
    case 'multipicklist':
      return 'multipicklist'
    case 'url':
      return 'url'
    case 'rich text area':
      return 'textarea'
    case 'long text area':
      return 'textarea'
    case 'textarea':
      return 'textarea'
    case 'phone':
      return 'phone2'
    case 'email':
      return 'email'
    case 'currency':
      return 'currency'
    case 'date':
      return 'date'
    case 'time':
      return 'time'
    case 'date/time':
    case 'datetime':
      return 'datetime'
    case 'reference':
      return 'reference'
  }
  switch (groupedTypes) {
    case 'datetime':
      return 'datetime'
    case 'time':
      return 'time'
    case 'date':
      return 'date'
    case 'number':
      return 'number'
    case 'boolean':
      return 'boolean'
    case 'string':
      return 'text'
    default:
      return 'text'
  }
}
